import { SecondaryButton } from "./Button";
import { useTranslation } from "react-i18next";
const warrantyImage = require("../assets/images/warranty.jpg");

export default function LinkNotValid() {
  const { t } = useTranslation();
  return (
    <div className="flex mt-8 justify-center items-center flex-col gap-8  px-8">
      <img src={warrantyImage} className="mx-auto" alt="" />
      <p className="text-red-600  text-lg font-semibold -my-4">
        {t("This link is not valid.")}
      </p>
      <p className="text-[#5A5A5A] text-center">
        {t(
          "Please contact ProtectAll by GBS for assistance with your warranty number via Toll Free Number listed on your plan or email us at"
        )}
        <br />
        <a
          href="mailto:support@myprotectall.com"
          className="underline cursor-pointer text-brand-color"
        >
          support@myprotectall.com
        </a>
      </p>
      <a href="/" className="flex gap-2 w-full">
        <SecondaryButton className="text-blue-600 bg-blue-100">
          {t("Back to Home")}
        </SecondaryButton>
      </a>
    </div>
  );
}
